
import { SvgIcon, SvgIconProps } from "@mui/material";
    
export const TemplateIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
   <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M21 9H3M8.62 9v12"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2Z" clip-rule="evenodd"/></svg>
  </SvgIcon>
);
